import { useKimLhc } from '@/context/KimLhc';
import { useHandleActions } from './useHandleActions';
import { useApplicationContext } from '@/context/v1/Application/context';
import { FieldNamesEnum, FormFields } from '@/components/views/Report/KimLhc/types';

const GENERAL_INFO_FIELD_PATHS: [string, string][] = [
	[FieldNamesEnum.GENERAL_INFORMATION, 'organization_id'],
	[FieldNamesEnum.GENERAL_INFORMATION, 'company_id'],
	[FieldNamesEnum.GENERAL_INFORMATION, 'sector_id'],
	[FieldNamesEnum.GENERAL_INFORMATION, 'line_id'],
	[FieldNamesEnum.GENERAL_INFORMATION, 'workstation_id'],
	[FieldNamesEnum.GENERAL_INFORMATION, 'activity_id'],
	[FieldNamesEnum.GENERAL_INFORMATION, 'evaluator_id'],
	[FieldNamesEnum.GENERAL_INFORMATION, 'collect_date'],
	[FieldNamesEnum.GENERAL_INFORMATION, 'workday_duration'],
	[FieldNamesEnum.GENERAL_INFORMATION, 'activity_duration']
];

export function useGeneralInformation() {
	const { organization, company } = useApplicationContext();
	const { file_id, report_id, form, currentStep, onNextStep } = useKimLhc();
	const { handleCreateKimLhcReport, handleUpdateKimLhcReport, handleUpdateStepAndCommentKimLhcReport, isLoading } =
		useHandleActions();

	async function handleSubmit(values: FormFields): Promise<void> {
		const generalInfo = values.general_information;

		const basePayload = {
			workstation_id: generalInfo.workstation_id,
			line_id: generalInfo.line_id,
			sector_id: generalInfo.sector_id,
			company_id: generalInfo.company_id || company.id,
			organization_id: generalInfo.organization_id || organization.id,
			activity_id: generalInfo.activity_id,
			evaluator_id: generalInfo.evaluator_id,
			day_duration: generalInfo.workday_duration,
			activity_duration: generalInfo.activity_duration,
			collect_date: generalInfo.collect_date!.format('YYYY-MM-DD')
		};

		if (!report_id) {
			await handleCreateKimLhcReport({
				file_id: file_id!,
				step: 1,
				...basePayload
			});
			return;
		}

		function hasChanges(): boolean {
			return GENERAL_INFO_FIELD_PATHS.some(path => form.isFieldTouched(path));
		}

		if (!hasChanges) {
			await handleUpdateStepAndCommentKimLhcReport({
				id: report_id,
				file_id: file_id!,
				step: currentStep + 1,
				organization_id: organization.id,
				company_id: company.id
			});
			onNextStep();
			return;
		}

		await handleUpdateKimLhcReport({
			id: report_id,
			file_id: file_id!,
			step: currentStep + 1,
			...basePayload
		});
	}

	return {
		handleSubmit,
		isLoading
	};
}
